import React from 'react';
import { useProperty } from '../../hooks/useProperty';
import { FORMS } from '../../schemas/stepMap';
import { Helmet } from 'react-helmet';
import FormBuilder from '../../components/formBuilder';
import { useNavigate } from 'react-router-dom';
import PropertyPageHeader from '../../components/PropertyPageHeader';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase/clientApp';
import { useUser } from '../../hooks/useUser';

const RefinancingWorksheet = () => {
  const { propertyData, scenarios } = useProperty();
  const { user } = useUser();
  const navigate = useNavigate();

  if (propertyData?.projectType === 'flip') {
    navigate('../flip-worksheet');
  }

  const scenario = scenarios.find((scenario) => scenario.isDefault !== true);

  const refinancingSchema = FORMS.refinancing.schema;

  const userScenarioId = scenario ? scenario.id : null;

  function logCompleted() {
    logEvent(analytics, 'brrrr_analysis_worksheet_completed', {
      user_id: user?.uid,
      property_id: propertyData?.propertyId,
    });
  }

  return (
    <>
      <Helmet>
        <title>PropertyCast.io - BRRRR Worksheet</title>
      </Helmet>
      <section id="BRRRRWorksheet">
        <PropertyPageHeader
          title={refinancingSchema.inputs.title}
          description={refinancingSchema.inputs.description}
        />

        <FormBuilder
          formSchema={refinancingSchema}
          formType={FORMS.refinancing.formType}
          beforeData={{ ...propertyData, ...scenario }}
          data={scenario}
          docId={userScenarioId}
          onFormSubmitted={logCompleted}
        />
      </section>
    </>
  );
};

export default RefinancingWorksheet;
